import React from "react";

// Style
import Styles from "./approvalBox.module.scss";

function ApprovalBox({ pendingServices }: any) {
  return (
    <div className={Styles.demoInfo} data-testid="approval-box">
      <h6>Note</h6>
      <p data-testid="approval-box-summary">
        {" "}
        {pendingServices.length}{" "}
        {pendingServices.length > 1 ? "products are" : "product is"} awaiting
        approval for trial
      </p>
      <ul data-testid="approval-box-pending-list">
        {pendingServices.map((service: any, index: number) => (
          <li key={index} data-testid={`approval-box-service-${index}`}>
            {service.product_name ?? service.name}
          </li>
        ))}
      </ul>
      <p>Please note that the admin is working towards the approval for you.</p>
      <p>Thank you for your patience!</p>
    </div>
  );
}

export default ApprovalBox;
